
export default {
    name: 'ModalVoucherExplained',

    props: {
        title: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
        voucher: {
            type: Object,
            default: null,
        },
    },

    computed: {
        description() {
            return this.voucher?.appliesTo === 'STOREFRONT'
                ? this.$t('cart.labels.voucher.storefront.modal_text', [
                      this.voucher.storefront.name,
                  ])
                : this.voucher?.appliesTo === 'FILTER_VALUE'
                ? this.$t('cart.labels.voucher.filter.modal_text')
                : ''
        },
        extraDescription() {
            return this.voucher?.type === 'REUSABLE_NEW_CONNECTIONS'
                ? this.$t('cart.labels.voucher.new_brands.modal_text')
                : ''
        },
    },
}
